import { render, staticRenderFns } from "./ProducersTableRowDetails.vue?vue&type=template&id=3868ff3a&"
import script from "./ProducersTableRowDetails.vue?vue&type=script&lang=js&"
export * from "./ProducersTableRowDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports